import React from 'react';
import JobDetailPage from './JobDetailPage';

// /announcement/find/:jobPostingCode 경로에서 직접 접근 시 사용
// JobDetail(nested route)과 달리 container 클래스가 없으므로 여기서 감싸줌
const JobDetailStandalone = () => {
    return (
        <main className="container type_gray">
            <JobDetailPage />
        </main>
    );
};

export default JobDetailStandalone;
